<section [formGroup]="currentForm">
  <div flex fxLayout="column" fxLayoutAlign="center">
    <mat-form-field fxFlex="100">
      <mat-label>Messlokation</mat-label>
      <input matInput type="text" formControlName="meLo" />
    </mat-form-field>
  </div>

  <div flex fxLayout="column" fxLayoutAlign="center">
    <mat-form-field fxFlex="100">
      <mat-label>Marktlokation</mat-label>
      <input matInput type="text" formControlName="maLo" />
    </mat-form-field>
  </div>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button mat-raised-button color="primary" id="modal-confirm-after-meter-change" (click)="confirm()">
      <span>Abschicken</span>
    </button>
  </div>
</section>
